const Kategoriya2221 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 2-chorak<br />
                Mavzu: So‘z ichida yonma-yon kelgan bir xil undoshlar talaffuzi va imlosini o‘rganamiz <br />
“Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Nuqtalar o‘rniga yonma-yon kelgan kk undoshli so‘zlarni qo‘ying.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘zlar imlosi ustida ishlash ko‘nikmalarini rivojlantirish. <br />
            <i>Mashg‘ulot davomiyligi:</i> 3 daqiqa.<br />
            <p>Ma……a, ma……on, da……i, du……ak, u……i</p>
            <p><b>2-mashq. Juftlikda ishlang. Kerakli o‘rinlarga yonma-yon kelgan rr undoshlarini qo‘ying va yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning so‘zlar imlosi ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">A……a - ________________________________________</p>
            <p className="text-break">Ma……a - _______________________________________</p>
            <p><b>3-mashq. Tez aytishni o‘qing va yonma-yon kelgan undoshning tagiga chizing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Tursunda to‘rtta to‘r qop,</p>
            <p>Unsinda bitta qo‘lqop bor.</p>
        </div>
    )
}
export default Kategoriya2221;